import { type PropsWithChildren, createContext, useContext } from 'react';
import { GqlValidatorStatus } from '../../../graphql/base-types.graphql';

interface Props {
  validatorStatus?: GqlValidatorStatus | null;
}

const Context = createContext<Props>({});

export const StepperStepContentProvider = ({ children, ...props }: PropsWithChildren<Props>) => {
  return <Context.Provider value={props}>{children}</Context.Provider>;
};

export const useStepperStepContent = () => useContext(Context);
